"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var React = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _FormControl = _interopRequireDefault(require("react-bootstrap/lib/FormControl"));

var _ThemeProvider = require("../../ThemeProvider");

var _classnames = _interopRequireDefault(require("classnames"));

var _textSecurityDisc = _interopRequireDefault(require("text-security/dist/text-security-disc.woff"));

var cancelEvent = function cancelEvent(e) {
  e.stopPropagation();
  e.preventDefault();
  return false;
};

var makeStyle = function makeStyle() {
  return {
    Password: {
      '@global': {
        '@font-face': {
          fontFamily: 'passwdfont',
          src: "url(".concat(_textSecurityDisc["default"], ") format('woff')"),
          fontWeight: 'normal',
          fontStyle: 'normal'
        }
      },
      fontFamily: 'passwdfont !important'
    }
  };
};

var PasswordWithoutCompletion = function PasswordWithoutCompletion(_ref) {
  var classes = _ref.classes,
      className = _ref.className,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["classes", "className"]);
  return /*#__PURE__*/React.createElement(_FormControl["default"], (0, _extends2["default"])({}, props, {
    className: (0, _classnames["default"])(classes.Password, className),
    type: "text",
    autoComplete: false,
    onCopy: cancelEvent,
    onCut: cancelEvent,
    spellCheck: false
  }));
};

PasswordWithoutCompletion.propTypes = {
  classes: _propTypes["default"].shape({
    Password: _propTypes["default"].string.isRequired
  }).isRequired,
  className: _propTypes["default"].string
};

var _default = (0, _ThemeProvider.withStyles)(makeStyle)(PasswordWithoutCompletion);

exports["default"] = _default;
//# sourceMappingURL=password-nofill.js.map